import { Fragment, useState, useEffect, useCallback } from 'react';
import { Layout, Table, Radio, DatePicker, Button, message } from 'antd';
import AuthUserDepartmentEcharts from './AuthUserDepartmentEcharts';
import { get } from '@/core/request';
import { lastDays, timeString, todayDateString } from '@/utils/utils';
import dayjs from 'dayjs';
import '../ActiveUser/ActiveUser.less';
import PageHeader from '@components/PageHeader/PageHeader';

const { RangePicker } = DatePicker;
export default function AuthUserDepartment() {
    // 渲染table数据的state
    const [tableData, setTableData] = useState([]);
    const [chartData, setChartData] = useState({
        xData: [],
        yData: [],
    });

    const dateFormat = 'YYYY-MM-DD';

    const date = new Date();
    // 当天
    const dateString = todayDateString(date);
    const startdate = lastDays(1);
    // 七天前   30天前
    const [dateStringStart, setDateStringStart] = useState(startdate);
    // 当天
    const [dateStringEnd, setDateStringEnd] = useState(startdate);

    const [timeRadio, setTimeRadio] = useState('yesterday');

    useEffect(() => {
        var days = (Date.parse(dateStringEnd) - Date.parse(dateStringStart)) / (1 * 24 * 60 * 60 * 1000);
        if (days > 90) {
            message.error('时间区间不得超过90天');
            return;
        }
        // 渲染table数据
        get(`/user/data/statistics/detail/users-office-detail`, {
            endTime: dateStringEnd,
            startTime: dateStringStart,
        }).then(res => {
            if (res.status_code === 200) {
                if (res.data) {
                    res.data.forEach(item => {
                        if (!item.children.length) {
                            delete item.children;
                        } else {
                            item.children.forEach(elem => {
                                elem.key = elem.type;
                            });
                        }
                        item.key = item.type;
                    });
                    setTableData(res.data);
                }
            }
        });
        // 渲染echarts数据
        get(`/user/data/statistics/detail/users-detail`, {
            endTime: dateStringEnd,
            startTime: dateStringStart,
            type: 2,
        }).then(res => {
            if (res.status_code === 200) {
                const xArr = [];
                const yArr = [];
                res.data
                    && res.data.forEach(item => {
                        xArr.push(item.dicName);
                        yArr.push(item.num);
                    });
                setChartData({
                    xData: xArr,
                    yData: yArr,
                });
            }
        });
    }, [dateStringEnd, dateStringStart]);

    // 改变时间
    const handleChangeValue = e => {
        setTimeRadio(e.target.value);
        let startdateInner = '';
        if (e.target.value === 'yesterday') {
            setDateStringStart(startdate);
            setDateStringEnd(startdate);
            return;
        } else if (e.target.value === 'seven') {
            startdateInner = lastDays(6);
        } else {
            startdateInner = lastDays(29);
        }
        setDateStringStart(startdateInner);
        setDateStringEnd(dateString);
    };

    // 搜索的自定义时间 控制为90天

    const disabledDate = current => {
        return current > dayjs(startdate, dateFormat);
    };

    const handleChangeTime = (value, dateString) => {
        setDateStringStart(dateString[0]);
        setDateStringEnd(dateString[1]);
        setTimeRadio('');
    };

    // 导出数据
    const handleExportFile = () => {
        var days = (Date.parse(dateStringEnd) - Date.parse(dateStringStart)) / (1 * 24 * 60 * 60 * 1000);
        if (days > 90) {
            message.error('时间区间不得超过90天');
            return;
        }
        get(
            `/user/data/statistics/detail/users-office-detail-download`,
            {
                endTime: dateStringEnd,
                startTime: dateStringStart,
            },
            { responseType: 'blob' },
        ).then(res => {
            if (res.size !== 0) {
                message.success('请稍后，正在导出');
                const date = new Date();
                const dateString = timeString(date);
                const fileName = `医务人员科室分布${dateString}.xlsx`;
                const a = document.createElement('a');
                const event = new MouseEvent('click');
                a.download = fileName;
                const objectUrl = URL.createObjectURL(res);
                a.href = objectUrl;
                a.dispatchEvent(event);
                URL.revokeObjectURL(objectUrl);
            } else {
                message.warning('当前列表没有数据，无法导出');
            }
        });
    };

    // table 数据相关
    const columns = [
        { title: '科室', dataIndex: 'typeName' },
        { title: '医务人员数', dataIndex: 'num' },
    ];

    return (
        <Fragment>
            <PageHeader breadcrumb={[]}>医务人员科室分布</PageHeader>

            <div className="page-route-body page-route-body-active">
                <div className="active-user-title">统计时间</div>

                <div className="bi-user-overview-time-box">
                    <Radio.Group onChange={handleChangeValue} size="medium" value={timeRadio} className="bi-user-overview-time-box-left">
                        <Radio.Button value="yesterday">昨天</Radio.Button>
                        <Radio.Button value="seven">最近7天</Radio.Button>
                        <Radio.Button value="thirty">最近30天</Radio.Button>
                    </Radio.Group>

                    {dateStringStart && <RangePicker size="medium" allowClear={false} value={[dayjs(dateStringStart, dateFormat), dayjs(dateStringEnd, dateFormat)]} disabledDate={disabledDate} onChange={handleChangeTime} style={{ width: 260 }} />}
                </div>

                <div className="active-user-title">医务人员科室分布</div>

                <AuthUserDepartmentEcharts chartData={chartData}></AuthUserDepartmentEcharts>

                <div className="active-user-title">
                    <span>数据明细</span>
                    <div className="table-toolbar">
                        <Button type="default" onClick={handleExportFile}>
                            <i className="bi bi-download"></i>
                            导出
                        </Button>
                    </div>
                </div>

                <Table className="enterprise-table" columns={columns} dataSource={tableData} pagination={false} />
            </div>
        </Fragment>
    );
}
